// 색상 스타일가이드에 따른 색상 정의
export const colors = {
  // Main Colors
  main: {
    bg01: '#FFFFFF',      // BG01
    bg02: '#FFFCF0',      // BG02  
    primary: '#FDD751',   // Primary
    text01: '#333333',    // Text01
    text02: '#757575',    // Text02
    text03: '#FFFFFF',    // Text03
  },
  
  // Grayscale
  grayscale: {
    hardest: '#8F8F8F',   // Hardest
    hard: '#BFBFBF',      // Hard
    light: '#F0F1F5',     // Light
    lightest: '#F7F8FA',  // Lightest
  },
  
  // Palette
  palette: {
    error: '#FE536B',     // Error
    info: '#868AFF',      // Info
    success: '#ACDE5F',   // Success
    warning: '#FFB13C',   // Warning
  }
};

// CSS Variables로 변환하는 함수
export const createCSSVariables = () => {
  const cssVars = {};
  
  Object.entries(colors).forEach(([category, colorObj]) => {
    Object.entries(colorObj).forEach(([name, value]) => {
      cssVars[`--color-${category}-${name}`] = value;
    });
  });
  
  return cssVars;
};

// Material-UI Theme에서 사용할 색상 팔레트
export const createThemePalette = () => ({
  primary: {
    main: colors.main.primary,
    contrastText: colors.main.text03,
  },
  secondary: {
    main: colors.palette.warning,
    contrastText: colors.main.text03,
  },
  error: {
    main: colors.palette.error,
  },
  success: {
    main: colors.palette.success,
  },
  info: {
    main: colors.palette.info,
  },
  warning: {
    main: colors.palette.warning,
  },
  background: {
    default: colors.main.bg01,
    paper: colors.main.bg02,
  },
  text: {
    primary: colors.main.text01,
    secondary: colors.main.text02,
  },
  grey: {
    50: colors.grayscale.lightest,
    100: colors.grayscale.light,
    400: colors.grayscale.hard,
    600: colors.grayscale.hardest,
  }
});